module.exports = __webpack_public_path__ + "static/media/sound.5c1d16f9.svg";